export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9776.401dfc59.jpg";